module.exports = __webpack_public_path__ + "assets/img/tiekimas.973fa60a.jpg";